import {connect} from 'react-redux';
import PropertyDetails from 'app/components/RightBarPane/Property/PropertyDetails';
import {convertListToArray} from 'app/shared/utils';

export const mapStateToProps = (state) => ({
    details: convertListToArray(state.getIn(['property', 'selectedProperty', 'details'])),
    parcels: convertListToArray(state.getIn(['property', 'selectedProperty', 'parcels'])),
});

export default connect(mapStateToProps, null)(PropertyDetails);